<template>
  <div class="flex act-container">
    <div>
      <act-preview
        phoneHeaderFixed
        navigationBg="transparent"
        phoneBodyOverflowHidden
        navigationTitle="邀请领现金"
        phoneHeaderFixedColor="#fff"
      >
        <div slot="headerSlot" class="text-center" style="color: #fff">
          全国有{{ ruleForm.visualJoinNum }}人正在参加
        </div>

        <div
          class="slot"
          :style="{ backgroundImage: 'url(' + ruleForm.spreadBgp2 + ')' }"
        >
          <div class="change-bg">
            <el-upload
              ref="upload"
              :data="{ fileDir: 'mall' }"
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :onError="uploadError"
              :onSuccess="cropUploadSuccess2"
              :beforeUpload="beforeAvatarUpload"
              :onProgress="uploading"
              :show-file-list="uploadShow"
              :disabled="disabled"
            >
              <div class="upload-img pointer" v-if="ruleForm.spreadBgp2">
                更换背景
              </div>
            </el-upload>
          </div>
          <div style="padding-top: 90px">
            <div class="title-img-wrapper redeem-upload prev-upload">
              <div class="upload-img" v-if="ruleForm.spreadBgp3">
                <el-upload
                  :disabled="disabled"
                  ref="upload"
                  :data="{ fileDir: 'mall' }"
                  :headers="{ 'X-Access-Token': $token }"
                  :action="$uploadUrl"
                  :onError="uploadError"
                  :onSuccess="cropUploadSuccess3"
                  :beforeUpload="beforeAvatarUpload"
                  :onProgress="uploading"
                  :show-file-list="uploadShow"
                >
                  <span class="hmicon icon-shangchuantupian1"></span>
                </el-upload>
              </div>
              <img class="header-img" :src="ruleForm.spreadBgp3" alt="" />
              <div class="rolling">
                <div class="notice-box flex">
                  <div class="notice text-center">
                    <span class="hmicon icon-tongzhi2x"></span>
                  </div>
                  <div class="flex-1 notice-people" style="font-size: 12px">
                    王*凯获得88.00元 李*三 获得88.00元
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="title-content-wrapper">
            <div class="p10">
              <div class="title-content">邀请收益</div>
              <div class="mt10 mb20 flex flex-between">
                <div>
                  已到手红包<span class="primary bold">￥</span
                  ><span class="primary price bold">20.00</span>
                </div>
                <div class="form-item-tip">红包直接发放到微信零钱</div>
              </div>
              <div
                class="mt10 flex flex-between"
                v-for="(v, i) in earningsList"
                :key="i"
              >
                <div class="bold">
                  {{ v.goodsName }}
                </div>
                <div class="bold">
                  {{ v.price }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </act-preview>
    </div>
    <div class="add-goods-container">
      <div class="act-step-wrapper">
        <hm-step
          :steps="steps"
          :scroll="true"
          :step="currentStep"
          @scroll="windowScroll"
        ></hm-step>
      </div>
      <div class="act-wrapper">
        <el-scrollbar :style="{ height: scrollHeight + 'px' }">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="170px"
          >
            <div id="base">1.基本信息</div>
            <el-form-item label="活动标题" prop="spreadName">
              <el-input
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                maxlength="25"
                v-model.trim="ruleForm.spreadName"
                placeholder="请输入活动标题"
                :disabled="disabled"
              ></el-input>
            </el-form-item>

            <el-form-item label="活动时间段选择" prop="activityDate">
              <el-date-picker
                :default-time="['00:00:00', '23:59:59']"
                v-model="ruleForm.activityDate"
                type="datetimerange"
                align="right"
                :picker-options="pickerOptions"
                start-placeholder="活动开始时间"
                end-placeholder="活动结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
                :disabled="disabled"
              ></el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="背景音乐链接" prop="spreadBgm">
              <el-input
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model="ruleForm.spreadBgm"
                placeholder="请输入音乐链接/音乐网络地址"
                :disabled="disabled"
              ></el-input>
            </el-form-item> -->
            <el-form-item label="弹窗入口" prop="spreadBgp1">
              <div v-if="ruleForm.spreadBgp1" class="flex">
                <div class="mr10 flex item-end priview">
                  <el-image
                    class="img"
                    :src="ruleForm.spreadBgp1"
                    alt="logo"
                    :preview-src-list="[ruleForm.spreadBgp1]"
                  />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button
                      type="text"
                      :disabled="disabled"
                      @click="handleRemove('spreadBgp1')"
                      >删除</el-button
                    >
                  </div>
                </div>
                <div class="el-upload__tip">
                  <span class="mr">
                    上传图片注意：
                    <br />1.建议图片尺寸590*700 <br />2.图片格式：png、jpg、bmp
                  </span>
                </div>
              </div>

              <el-upload
                v-else
                class="upload flex"
                ref="upload"
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :action="$uploadUrl"
                :onError="uploadError"
                :onSuccess="cropUploadSuccess"
                :beforeUpload="beforeAvatarUpload"
                :onProgress="uploading"
                :show-file-list="uploadShow"
                :disabled="disabled"
              >
                <div class="flex upload-upload-btn">
                  <div class="btn flex flex-column flex-center open-file">
                    <div class="add-wrapper">
                      <span
                        class="hmicon icon-hao pointer"
                        style="margin-right: 0px"
                      ></span>
                    </div>
                    <span class="gray">上传弹窗图</span>
                  </div>
                </div>

                <div class="el-upload__tip" slot="tip">
                  <span class="mr">
                    上传图片注意：
                    <br />1.建议图片尺寸590*700 <br />2.图片格式：png、jpg、bmp
                  </span>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="首页浮动入口" prop="spreadBgp4">
              <div v-if="ruleForm.spreadBgp4" class="flex">
                <div class="mr10 flex item-end priview">
                  <el-image
                    class="img"
                    :src="ruleForm.spreadBgp4"
                    alt="logo"
                    :preview-src-list="[ruleForm.spreadBgp1]"
                  />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button
                      type="text"
                      :disabled="disabled"
                      @click="handleRemove('spreadBgp4')"
                      >删除</el-button
                    >
                  </div>
                </div>
                <div class="el-upload__tip">
                  <span class="mr">
                    上传图片注意：
                    <!-- <br />1.建议图片尺寸590*700 <br />2.图片格式：png、jpg、bmp -->
                    <br />1.图片格式：png、jpg、bmp
                  </span>
                </div>
              </div>

              <el-upload
                v-else
                class="upload flex"
                ref="upload"
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :action="$uploadUrl"
                :onError="uploadError"
                :onSuccess="cropUploadSuccess4"
                :beforeUpload="beforeAvatarUpload"
                :onProgress="uploading"
                :show-file-list="uploadShow"
                :disabled="disabled"
              >
                <div class="flex upload-upload-btn">
                  <div class="btn flex flex-column flex-center open-file">
                    <div class="add-wrapper">
                      <span
                        class="hmicon icon-hao pointer"
                        style="margin-right: 0px"
                      ></span>
                    </div>
                    <span class="gray">上传首页浮动图</span>
                  </div>
                </div>

                <div class="el-upload__tip" slot="tip">
                  <span class="mr">
                    上传图片注意：
                    <!-- <br />1.建议图片尺寸590*700 <br />2.图片格式：png、jpg、bmp -->
                    <br />1.图片格式：png、jpg、bmp
                  </span>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="上传背景图" prop="spreadBgp2">
              <div v-if="ruleForm.spreadBgp2" class="flex">
                <div
                  class="mr10 flex item-end priview"
                  style="width: 300px; height: 500px"
                >
                  <el-image
                    class="img"
                    :src="ruleForm.spreadBgp2"
                    alt="logo"
                    :preview-src-list="[ruleForm.spreadBgp2]"
                  />
                  <!-- <img :src="ruleForm.spreadBgp2" alt="logo" /> -->
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button
                      type="text"
                      :disabled="disabled"
                      @click="handleRemove('spreadBgp2')"
                      >删除</el-button
                    >
                  </div>
                </div>
                <div class="el-upload__tip">
                  <span class="mr">
                    上传图片注意：
                    <br />1.建议图片尺寸750*1334 <br />2.图片格式：png、jpg、bmp
                  </span>
                </div>
              </div>

              <el-upload
                v-else
                class="upload flex"
                ref="upload"
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :action="$uploadUrl"
                :onError="uploadError"
                :onSuccess="cropUploadSuccess2"
                :beforeUpload="beforeAvatarUpload"
                :onProgress="uploading"
                :show-file-list="uploadShow"
                :disabled="disabled"
              >
                <div class="flex upload-upload-btn">
                  <div class="btn flex flex-column flex-center open-file">
                    <div class="add-wrapper">
                      <span
                        class="hmicon icon-hao pointer"
                        style="margin-right: 0px"
                      ></span>
                    </div>
                    <span class="gray">上传活动背景图</span>
                  </div>
                </div>

                <div class="el-upload__tip" slot="tip">
                  <span class="mr">
                    上传图片注意：
                    <br />1.建议图片尺寸750*1334 <br />2.图片格式：png、jpg、bmp
                  </span>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="奖励背景图" prop="spreadBgp3">
              <div v-if="ruleForm.spreadBgp3" class="flex">
                <div class="mr10 flex item-end priview">
                  <el-image
                    class="img"
                    :src="ruleForm.spreadBgp3"
                    alt="logo"
                    :preview-src-list="[ruleForm.spreadBgp3]"
                  />
                  <!-- <img :src="ruleForm.spreadBgp3" alt="logo" /> -->
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button
                      type="text"
                      :disabled="disabled"
                      @click="handleRemove('spreadBgp3')"
                      >删除</el-button
                    >
                  </div>
                </div>
                <div class="el-upload__tip">
                  <span class="mr">
                    上传图片注意：
                    <br />1.建议图片尺寸690*712 <br />2.图片格式：png、jpg、bmp
                  </span>
                </div>
              </div>

              <el-upload
                v-else
                class="upload flex"
                ref="upload"
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :action="$uploadUrl"
                :onError="uploadError"
                :onSuccess="cropUploadSuccess3"
                :beforeUpload="beforeAvatarUpload"
                :onProgress="uploading"
                :show-file-list="uploadShow"
                :disabled="disabled"
              >
                <div class="flex upload-upload-btn">
                  <div class="btn flex flex-column flex-center open-file">
                    <div class="add-wrapper">
                      <span
                        class="hmicon icon-hao pointer"
                        style="margin-right: 0px"
                      ></span>
                    </div>
                    <span class="gray">上传奖励背景图</span>
                  </div>
                </div>

                <div class="el-upload__tip" slot="tip">
                  <span class="mr">
                    上传图片注意：
                    <br />1.建议图片尺寸690*712 <br />2.图片格式：png、jpg、bmp
                  </span>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="虚拟参与人数" prop="visualJoinNum">
              <span>在实际参与人数基础上增加</span>
              <el-input
                @mousewheel.prevent.native
                style="width: 100px"
                size="small"
                clearable
                :disabled="disabled"
                @input="filterGt0OrFixed0('visualJoinNum')"
                maxlength="5"
                class="mr10 ipt"
                v-model.trim="ruleForm.visualJoinNum"
                placeholder="请输入数字"
              ></el-input
              >人
              <!-- <div class="form-tip">
                显示在手机端，已参与活动人数=实际参与人数加上此处设置的虚拟人数
              </div> -->
            </el-form-item>
            <!-- <el-form-item label="分享按钮图" prop="spreadBgp4">
              <el-upload
                class="upload flex"
                ref="upload"
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :action="$uploadUrl"
                :onError="uploadError"
                :onSuccess="cropUploadSuccess4"
                :beforeUpload="beforeAvatarUpload"
                :onProgress="uploading"
                :show-file-list="uploadShow"
              >
                <div
                  v-if="ruleForm.spreadBgp4"
                  class="mr10 flex item-end priview"
                >
                  <img :src="ruleForm.spreadBgp4" alt="logo" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="handleRemove('spreadBgp4')"
                      >删除</el-button
                    >
                  </div>
                </div>
                <div v-else class="flex upload-upload-btn">
                  <div class="btn flex flex-column flex-center open-file">
                    <div class="add-wrapper">
                      <span
                        class="hmicon icon-hao pointer"
                        style="margin-right: 0px"
                      ></span>
                    </div>
                    <span class="gray">上传分享按钮图</span>
                  </div>
                </div>

                <div class="el-upload__tip" slot="tip">
                  <span class="mr">
                    上传图片注意：
                    <br />1.建议图片尺寸590*890 <br />2.图片格式：png、jpg、bmp
                  </span>
                </div>
              </el-upload>
            </el-form-item> -->
            <el-form-item label="分享消息文案" prop="spreadShareContent">
              <el-input
                :maxlength="30"
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                :disabled="disabled"
                v-model.trim="ruleForm.spreadShareContent"
                placeholder="请输入分享消息文案，30字以内"
              ></el-input>
            </el-form-item>
            <el-form-item label="消息背景图" prop="spreadBgp5">
              <div v-if="ruleForm.spreadBgp5" class="flex">
                <div class="mr10 flex item-end priview">
                  <el-image
                    class="img"
                    :src="ruleForm.spreadBgp5"
                    alt="logo"
                    :preview-src-list="[ruleForm.spreadBgp5]"
                  />
                  <!-- <img :src="ruleForm.spreadBgp5" alt="logo" /> -->
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button
                      type="text"
                      :disabled="disabled"
                      @click="handleRemove('spreadBgp5')"
                      >删除</el-button
                    >
                  </div>
                </div>
                <div class="el-upload__tip">
                  <span class="mr">
                    上传图片注意：
                    <br />1.建议图片尺寸590*890 <br />2.图片格式：png、jpg、bmp
                  </span>
                </div>
              </div>

              <el-upload
                v-else
                class="upload flex"
                ref="upload"
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :action="$uploadUrl"
                :onError="uploadError"
                :onSuccess="cropUploadSuccess5"
                :beforeUpload="beforeAvatarUpload"
                :onProgress="uploading"
                :show-file-list="uploadShow"
                :disabled="disabled"
              >
                <div class="flex upload-upload-btn">
                  <div class="btn flex flex-column flex-center open-file">
                    <div class="add-wrapper">
                      <span
                        class="hmicon icon-hao pointer"
                        style="margin-right: 0px"
                      ></span>
                    </div>
                    <span class="gray">上传奖励背景图</span>
                  </div>
                </div>

                <div class="el-upload__tip" slot="tip">
                  <span class="mr">
                    上传图片注意：
                    <br />1.建议图片尺寸590*890 <br />2.图片格式：png、jpg、bmp
                  </span>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="活动规则说明" prop="spreadRuleRemark">
              <hm-rich-editor
                :disabled="disabled"
                v-model="ruleForm.spreadRuleRemark"
                :html="ruleForm.spreadRuleRemark"
              />
            </el-form-item>
            <el-form-item label="广告视频" prop="spreadBgv">
              <div v-if="ruleForm.spreadBgv" class="flex">
                <div class="priview-bgv">
                  <div
                    class="opreat-wrapper flex item-center flex-center"
                    style="width: 300px"
                  >
                    <el-button
                      type="text"
                      :disabled="disabled"
                      @click="handleRemove('spreadBgv')"
                      >删除</el-button
                    >
                  </div>
                  <video
                    v-if="ruleForm.spreadBgv"
                    :src="ruleForm.spreadBgv"
                    class="avatar"
                    style="width: 300px"
                    controls="controls"
                  >
                    您的浏览器不支持视频播放
                  </video>
                </div>
                <div class="el-upload__tip">
                  <span class="mr">
                    上传视频注意：
                    <br />1.请上传mp4格式视频 <br />2.不超过100M
                  </span>
                </div>
              </div>

              <el-upload
                v-else
                class="upload flex"
                :action="$uploadUrl"
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :show-file-list="videoFlag"
                :on-success="handleVideoSuccess"
                :before-upload="beforeUploadVideo"
                :on-progress="uploadVideoProcess"
                :on-remove="handleRemoveSpreadBgv"
                :disabled="disabled"
              >
                <div class="flex upload-upload-btn">
                  <div class="btn flex flex-column flex-center open-file">
                    <div class="add-wrapper">
                      <span
                        class="hmicon icon-hao pointer"
                        style="margin-right: 0px"
                      ></span>
                    </div>
                    <span class="gray">请上传视频广告</span>
                  </div>
                </div>
                <!-- <el-button
                  v-else-if="!ruleForm.spreadBgv && !videoFlag"
                  type="primary"
                  size="small"
                  >上传</el-button
                >
                <span class="form-tip">请上传mp4格式视频，不超过20M</span> -->
                <div class="el-upload__tip" slot="tip">
                  <span class="mr">
                    上传视频注意：
                    <br />1.请上传mp4格式视频 <br />2.不超过100M
                  </span>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="拓展表单：" prop="formStatus">
              <hm-form ref="hmform"> </hm-form>
            </el-form-item>

            <div id="gameRule">{{ steps.length === 3 ? 2 : 2 }}活动规则</div>
            <el-form-item label="总投放金额限制：" required>
              <div class="flex">
                <span>红包总发放达到 </span>
                <el-form-item prop="totalMonery">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.totalMonery"
                    placeholder="请输入金额"
                  ></el-input>
                </el-form-item>
                <span>元时停止发放红包，向用户展示文案 </span>
                <el-form-item prop="stopSHowMsg">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.stopSHowMsg"
                    placeholder="请输入展示文案"
                  ></el-input>
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item label="每日红包投放预算：" required>
              <div>
                <el-radio-group
                  v-model="ruleForm.everydaySpreadType"
                  :disabled="disabled"
                >
                  <el-radio label="0">不限</el-radio>
                  <el-radio label="1">限制投放金额</el-radio>
                </el-radio-group>
              </div>
              <div class="flex" v-if="ruleForm.everydaySpreadType === '1'">
                <span>每日红包达到 </span>
                <el-form-item prop="everydaySpreadInfoTouchValue">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    @input="filterGt0OrFixed2('everydaySpreadInfoTouchValue')"
                    style="width: 100px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.everydaySpreadInfoTouchValue"
                    placeholder="请输入金额"
                  ></el-input>
                </el-form-item>
                <span> 元时，向用户发放 </span>

                <el-form-item prop="everydaySpreadInfoLowerLimit">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    @input="filterGt0OrFixed2('everydaySpreadInfoLowerLimit')"
                    v-model.trim="ruleForm.everydaySpreadInfoLowerLimit"
                    placeholder="请输入金额"
                  ></el-input>
                </el-form-item>
                <span> 元～ </span>
                <el-form-item prop="everydaySpreadInfoUpperLimit">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    @input="filterGt0OrFixed2('everydaySpreadInfoUpperLimit')"
                    v-model.trim="ruleForm.everydaySpreadInfoUpperLimit"
                    placeholder="请输入金额"
                  ></el-input>
                </el-form-item>

                <span> 元的小额红包</span>
              </div>
            </el-form-item>
            <el-form-item label="红包触发预警：" required>
              <div class="flex">
                <span>达到总投放金额的 </span>
                <el-form-item prop="spreadWarnInfoTouchValue">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    size="small"
                    clearable
                    @input="filterGt0OrFixed2('spreadWarnInfoTouchValue')"
                    class="mr10 ipt"
                    v-model.trim="ruleForm.spreadWarnInfoTouchValue"
                    placeholder="请输入金额"
                  ></el-input>
                </el-form-item>
                <span>%时，向用户发放 </span>
                <el-form-item prop="spreadWarnInfoLowerLimit">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    @input="filterGt0OrFixed2('spreadWarnInfoLowerLimit')"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.spreadWarnInfoLowerLimit"
                    placeholder="请输入金额"
                  ></el-input>
                </el-form-item>
                <span> 元～ </span>
                <el-form-item prop="spreadWarnInfoUpperLimit">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    @input="filterGt0OrFixed2('spreadWarnInfoUpperLimit')"
                    v-model.trim="ruleForm.spreadWarnInfoUpperLimit"
                    placeholder="请输入金额"
                  ></el-input>
                </el-form-item>

                <span> 元的小额红包</span>
              </div>
            </el-form-item>
            <el-form-item label="红包预警提醒：" required>
              <div class="flex">
                <span>达到总投放金额的 </span>
                <el-form-item prop="spreadWarnRemindTouchValue">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    @input="filterGt0OrFixed2('spreadWarnRemindTouchValue')"
                    v-model.trim="ruleForm.spreadWarnRemindTouchValue"
                    placeholder="请输入金额"
                  ></el-input>
                </el-form-item>
                <span>%时，向管理员邮箱 </span>
                <!-- <el-form-item prop="contactsTel">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.contactsTel"
                    placeholder="请输入邮箱"
                  ></el-input>
                </el-form-item> -->
                发送预警消息
              </div>
            </el-form-item>
            <el-form-item label="分享者可得微信红包：" required>
              <div class="flex">
                <el-form-item prop="shareRedpackageLowerLimit">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    size="small"
                    clearable
                    @input="filterGt0OrFixed2('shareRedpackageLowerLimit')"
                    class="mr10 ipt"
                    v-model.trim="ruleForm.shareRedpackageLowerLimit"
                    placeholder="请输入金额"
                  ></el-input>
                </el-form-item>
                <span> 元～ </span>
                <el-form-item prop="shareRedpackageUpperLimit">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    @input="filterGt0OrFixed2('shareRedpackageUpperLimit')"
                    v-model.trim="ruleForm.shareRedpackageUpperLimit"
                    placeholder="请输入金额"
                  ></el-input
                  >元；
                </el-form-item>
              </div>
              <div style="font-size: 12px; color: #999; margin-top: 5px">
                导购分享给供货商后，供应商提交资料最高多少微信红包，0为无红包，最大不超过200
              </div>
            </el-form-item>
            <el-form-item label="接收邀请者微信红包：" required>
              <div class="flex">
                <el-form-item prop="receiveRedpackageLowerLimit">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    @input="filterGt0OrFixed2('receiveRedpackageLowerLimit')"
                    v-model.trim="ruleForm.receiveRedpackageLowerLimit"
                    placeholder="请输入金额"
                  ></el-input>
                </el-form-item>
                <span> 元～ </span>
                <el-form-item prop="receiveRedpackageUpperLimit">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    @input="filterGt0OrFixed2('receiveRedpackageUpperLimit')"
                    v-model.trim="ruleForm.receiveRedpackageUpperLimit"
                    placeholder="请输入金额"
                  ></el-input
                  >元；
                </el-form-item>
              </div>
              <div style="font-size: 12px; color: #999; margin-top: 5px">
                接收到邀请的用户最高多少微信红包，0为无红包，最大不超过200
              </div>
            </el-form-item>
            <el-form-item label="分享者红包限制：" required>
              <div class="flex">
                <span>分享者已领取红包 </span>
                <el-form-item prop="shareSpreadRestrictTouchValue">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    @input="filterGt0OrFixed0('shareSpreadRestrictTouchValue')"
                    v-model.trim="ruleForm.shareSpreadRestrictTouchValue"
                    placeholder="请输入次数"
                  ></el-input>
                </el-form-item>
                <span>次时，向分享者发放 </span>
                <el-form-item prop="shareSpreadRestrictLowerLimit">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    @input="filterGt0OrFixed2('shareSpreadRestrictLowerLimit')"
                    v-model.trim="ruleForm.shareSpreadRestrictLowerLimit"
                    placeholder="请输入金额"
                  ></el-input>
                </el-form-item>
                <span> 元～ </span>
                <el-form-item prop="shareSpreadRestrictUpperLimit">
                  <el-input
                    :disabled="disabled"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    @input="filterGt0OrFixed2('shareSpreadRestrictUpperLimit')"
                    v-model.trim="ruleForm.shareSpreadRestrictUpperLimit"
                    placeholder="请输入金额"
                  ></el-input>
                </el-form-item>
                元的小额红包
              </div>
              <div class="form-item-tip" style="margin-top: 15px">
                达到分享次数后只能返小额红包
              </div>
            </el-form-item>
            <div id="gameAstrict">{{ steps.length === 3 ? 3 : 3 }}活动限制</div>
            <el-form-item :label="labelName" prop="memberFromType">
              <el-radio-group
                v-model="ruleForm.memberFromType"
                :disabled="disabled"
              >
                <el-radio label="0">全部人员</el-radio>
                <el-radio label="1">指定用户</el-radio>
                <el-radio label="2">导入用户</el-radio>
              </el-radio-group>
              <div v-if="ruleForm.memberFromType === '1' && !disabled">
                <el-input
                  type="textarea"
                  style="width: 400px"
                  :rows="6"
                  placeholder="手动输入，一行一个号码，回车切换下一行，"
                  v-model="ruleForm.inputMobiles"
                  :disabled="disabled"
                >
                </el-input>
                <el-button
                  type="primary"
                  size="small"
                  @click="searchByPhone"
                  :disabled="disabled"
                  >查询</el-button
                >
                <div class="form-item-tip">
                  手动输入，一行一个号码，回车切换下一行，
                </div>
                <div class="form-item-tip">
                  每次最多能提交2000个号码。建议50个号码以上的用文件导入
                </div>
              </div>
              <div
                v-else-if="ruleForm.memberFromType === '2'"
                style="width: 500px"
              >
                <div class="flex flex-end mb10" v-if="!disabled">
                  <el-button size="small" @click="outputExcel" type="primary"
                    >导出模板</el-button
                  >
                  <el-button type="primary" class="open-file" size="small">
                    导入数据
                    <input
                      type="file"
                      @change="importf"
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    />
                  </el-button>
                </div>
              </div>
              <div style="width: 500px" v-if="ruleForm.memberFromType !== '0'">
                <el-table
                  stripe
                  border
                  ref="table"
                  :data="ruleForm.spreadActivityMemberInfos"
                  style="width: 100%"
                  max-height="400"
                  size="small"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    header-align="center"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="fromName"
                    label="用户名"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="fromMobile"
                    label="手机号"
                  >
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <div class="flex flex-center" v-if="!disabled">
                        <el-tooltip class="item" content="删除" placement="top">
                          <div
                            class="pointer mr10"
                            @click="removeGoods(scope.$index)"
                          >
                            <span class="hmicon icon-shanchu primary"></span>
                          </div>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
            <div class="flex flex-center">
              <el-button
                type="primary"
                size="small"
                v-if="!disabled"
                @click="submitForm('ruleForm')"
                >发布</el-button
              >
              <el-button size="small" @click="$router.back(-1)">返回</el-button>
            </div>
          </el-form>
        </el-scrollbar>
      </div>
      <!-- <el-dialog
        :close-on-click-modal="false"
        title="批量设置"
        :visible.sync="dialogVisible"
      >
        <div class=" flex flex-center">
          <div id="audio_btn" class="rotate">
            <audio
              :src="ruleForm.gameBgm"
              autoplay="true"
              loop="loop"
              id="audio1"
              preload="true"
            ></audio>
          </div>
          <img
            class="pvwimg"
            style="width:400px;height:667px"
            :src="ruleForm.spreadBgp1"
            alt=""
          />
          <p>已有 {{ 0 }}人参与</p>
          <p>您今天还有 {{ 3 }}次抽奖机会</p>
        </div>
        <div class="btn-wrapper flex flex-center">
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
        </div>
      </el-dialog>-->
    </div>
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div>
        <div>
          您有
          <span class="error">{{ errInputResult.length }}</span
          >条数据有误
        </div>
        <el-table
          max-height="400"
          size="small"
          stripe
          :data="errInputResult"
          border
          class="small-table"
        >
          <el-table-column
            prop="fromMobile"
            header-align="center"
            align="center"
            label="手机号查不到相关用户"
          ></el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="specBarcode"
            label="无效条码"
          ></el-table-column> -->
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HmStep from "@/components/HmStep";
// import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import actPreview from "@/components/actPreview";
import HmForm from "@/components/HmForm";
import XLSX from "xlsx";
import { arrayUnique2 } from "@/utils/utils";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串

export default {
  components: {
    HmStep,
    HmRichEditor,
    actPreview,
    HmForm
  },
  data() {
    const patternFormMember = (rule, val, callback) => {
      if (val != "0") {
        if (!this.ruleForm.spreadActivityMemberInfos.length) {
          return callback(new Error("请导入用户"));
        }
      }
      callback();
    };
    const patternFormMax = (rule, val, callback) => {
      if (new Number(val) > 200) {
        return callback(new Error("最大不超过200"));
      }
      callback();
    };
    const patternValueLimit = (rule, val, callback) => {
      if (new Number(val) < 0.3) {
        return callback(new Error("最小不能低于0.3"));
      }
      callback();
    };
    // const patternFormStatus = (rule, val, callback) => {
    //   if (this.$refs.hmform.list.length === 0) {
    //     return callback(new Error("请选择表单"));
    //   } else {
    //     let flag = false;
    //     this.$refs.hmform.list.forEach(v => {
    //       if (v.columnValue === "") {
    //         flag = true;
    //       }
    //       if (v.columnType === "radio") {
    //         v.paramInfoModels.forEach(o => {
    //           if (o.columnValue === "") {
    //             flag = true;
    //           }
    //         });
    //       }
    //     });
    //     if (flag) {
    //       return callback(new Error("请把表单填写完整"));
    //     }
    //   }

    //   callback();
    // };
    return {
      errInputResult: [],
      errValidGoods: false,
      disabled: false,
      earningsList: [
        {
          goodsName: "贝婴美",
          price: "+10.00"
        },
        {
          goodsName: "BOBO奶瓶",
          price: "+10.00"
        }
      ],
      videoUploadPercent: 0,
      videoFlag: false,
      uploadShow: true,
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        }
      },
      scrollHeight: 0,
      currentStep: 1,
      steps: [
        {
          id: "base",
          name: "基本信息"
        },
        {
          id: "gameRule",
          name: "活动规则"
        },
        {
          id: "gameAstrict",
          name: "活动限制"
        }
      ],
      rules: {
        spreadName: [
          {
            required: true,
            message: "请输入活动名称",
            trigger: "blur"
          },
          {
            required: true,
            min: 2,
            max: 16,
            message: "名称应大于2小于16个字",
            trigger: "blur"
          }
        ],
        activityDate: {
          required: true,
          message: "请选择活动时段",
          trigger: "blur"
        },
        spreadBgp1: {
          required: true,
          message: "请上传弹窗图",
          trigger: "blur"
        },
        spreadBgp2: {
          required: true,
          message: "请上传活动背景图",
          trigger: "blur"
        },
        spreadBgp3: {
          required: true,
          message: "请上传奖励背景图",
          trigger: "blur"
        },
        visualJoinNum: {
          required: true,
          message: "请输入虚拟参与人数",
          trigger: "blur"
        },
        spreadBgp4: {
          required: true,
          message: "请上传首页浮动入口图",
          trigger: "blur"
        },
        spreadShareContent: {
          required: true,
          message: "请输入分享消息文案",
          trigger: "blur"
        },
        spreadBgp5: {
          required: true,
          message: "请上传消息背景图",
          trigger: "blur"
        },
        spreadBgv: {
          required: true,
          message: "请上传视频广告",
          trigger: "blur"
        },
        formStatus: [
          //   {
          //     required: true,
          //     message: "请选择表单状态",
          //     trigger: "blur"
          //   },
          // { required: true, validator: patternFormStatus }
        ],
        totalMonery: {
          required: true,
          message: "请输入金额"
        },
        stopSHowMsg: {
          required: true,
          message: "请输入展示文案"
        },
        everydaySpreadInfoTouchValue: {
          required: true,
          message: "请输入金额"
        },
        everydaySpreadInfoLowerLimit: {
          required: true,
          message: "请输入金额"
        },
        everydaySpreadInfoUpperLimit: {
          required: true,
          message: "请输入金额"
        },
        spreadWarnInfoTouchValue: {
          required: true,
          message: "请输入百分比"
        },
        spreadWarnRemindTouchValue: {
          required: true,
          message: "请输入百分比"
        },
        spreadWarnInfoLowerLimit: [
          {
            required: true,
            message: "请输入金额"
          },

          { required: true, validator: patternValueLimit }
        ],
        spreadWarnInfoUpperLimit: [
          {
            required: true,
            message: "请输入金额"
          },
          { required: true, validator: patternValueLimit }
        ],
        contactsTel: [
          {
            required: true,
            message: "请输入邮箱"
          }
        ],
        shareRedpackageLowerLimit: [
          {
            required: true,
            message: "请输入金额"
          },
          { required: true, validator: patternFormMax }
        ],
        shareRedpackageUpperLimit: [
          {
            required: true,
            message: "请输入金额"
          },
          { required: true, validator: patternFormMax }
        ],
        receiveRedpackageLowerLimit: [
          {
            required: true,
            message: "请输入金额"
          },
          { required: true, validator: patternFormMax }
        ],
        receiveRedpackageUpperLimit: [
          {
            required: true,
            message: "请输入金额"
          },
          { required: true, validator: patternFormMax }
        ],
        shareSpreadRestrictTouchValue: {
          required: true,
          message: "请输入次数"
        },
        shareSpreadRestrictLowerLimit: [
          {
            required: true,
            message: "请输入金额"
          },
          { required: true, validator: patternValueLimit }
        ],
        shareSpreadRestrictUpperLimit: [
          {
            required: true,
            message: "请输入金额"
          },
          { required: true, validator: patternValueLimit }
        ],
        memberFromType: [
          {
            required: true,
            message: "请选择参与人员"
          },
          {
            required: true,
            validator: patternFormMember
          }
        ]
      },
      ruleForm: {
        spreadTarget: "",
        spreadName: "",
        activityDate: "",
        spreadStartTime: "",
        spreadEndTime: "",
        spreadBgm: "",
        spreadBgp1:
          "https://imgcdn.hemiao100.com/ThemePictures/%E7%BA%A2%E5%8C%85%402x.png",
        spreadBgp2:
          "https://imgcdn.hemiao100.com/ThemePictures/bg%403x222222.png",
        spreadBgp3: "https://imgcdn.hemiao100.com/ThemePictures/jianglibgp.png",
        visualJoinNum: "100",
        spreadBgp4:
          "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%AE%E7%AA%97.png",
        spreadShareContent: "邀请您使用禾销，顺便送您一个红包",
        spreadBgp5: "https://imgcdn.hemiao100.com/ThemePictures/jianglibgp.png",
        spreadRuleRemark:
          "<p><span style='color: rgb(237, 70, 47);'>一、玩法介绍：</span></p><p><span style='color: rgb(16, 16, 16);'>1.邀请厂商体验登录核销，即可获得随机红包；</span></p><p><span style='color: rgb(16, 16, 16);'>2.被邀请者加入组织内并登录核销，同样也获得随机红包；</span></p><p><span style='color: rgb(237, 70, 47);'>二、活动简介：</span></p><p><span style='color: rgb(16, 16, 16);'>1.随机抽取邀请厂商参与迎新红包活动；</span></p><p><span style='color: rgb(16, 16, 16);'>2.邀请成功标准：被邀请厂商成功提交信息，并且领取红包；</span></p><p><span style='color: rgb(237, 70, 47);'>三、注意事项:</span></p><p><span style='color: rgb(16, 16, 16);'>1.本次活动仅限中国内地地区用户，不支持港澳台地区；</span></p><p><span style='color: rgb(16, 16, 16);'>2.同一个手机号、同一个禾销账号和同一实名认证用户均视为同一用户。同一用户在活动期间只能以其所在的主企业的成员身份参与本活动；</span></p><p><span style='color: rgb(16, 16, 16);'>3.多个账号在同一设备登录，同一设备上登录的多个账号将被直接视为违规，禾苗有权取消违规账号的活动参与及领取红包的资格；</span></p><p><span style='color: rgb(16, 16, 16);'>4.在参与活动过程中，如存在违规行为（包括但不限于非真实手机设备、利用系统漏洞、黑客工具、软件作弊等非正常方式），禾苗将取消违规账号的活动参与及领取红包的资格，并禁止该违规用户参与禾苗其他活动；违规行为的具体认定以禾苗判定为准；</span></p><p><span style='color: rgb(16, 16, 16);'>5.禾苗将依法运营活动，但如活动受政府机关指令需要停止或调整举办的，或者活动受严重网络攻击或系统故障需要暂停举办的，则活动可能无法顺利进行，此种情况视为活动故障，禾苗及其关联公司均无须为活动故障承担赔偿或进行补偿；</span></p><p><span style='color: rgb(16, 16, 16);'>6.禾苗可以根据本活动的实际举办情况对活动规则进行变动或调整，相关变动或调整将公布在活动页面上，并于公布时即时生效。</span></p>",
        spreadBgv: "",
        formStatus: "open",
        totalMonery: "",
        stopSHowMsg: "红包悄悄溜走了",
        everydaySpreadType: "0",
        everydaySpreadInfoTouchValue: "", //everydaySpreadInfo{}每日红包投放预算
        everydaySpreadInfoUpperLimit: "", //everydaySpreadInfo{}
        everydaySpreadInfoLowerLimit: "", //everydaySpreadInfo{}
        spreadWarnInfoTouchValue: "90", //spreadWarnInfo{}红包触发预警
        spreadWarnInfoUpperLimit: "0.3", //spreadWarnInfo{}红包触发预警
        spreadWarnInfoLowerLimit: "0.3", //spreadWarnInfo{}红包触发预警
        spreadWarnRemindTouchValue: "90", //spreadWarnRemind{}红包预警提醒
        // contactsTel: "", //spreadWarnRemind{}
        shareRedpackageUpperLimit: "1",
        shareRedpackageLowerLimit: "0.1",
        receiveRedpackageUpperLimit: "1",
        receiveRedpackageLowerLimit: "0.1",
        shareSpreadRestrictTouchValue: "1", //shareSpreadRestrict
        shareSpreadRestrictUpperLimit: "0.3", //shareSpreadRestrict
        shareSpreadRestrictLowerLimit: "0.3", //shareSpreadRestrict
        memberFromType: "0",
        spreadActivityMemberInfos: [],
        inputMobiles: ""
      },
      type: "",
      labelName: "",
      memberPhoneList: []
      //   model: {
      //     rules: {
      //       spreadName: {
      //         required: true,
      //         message: "请输入活动名称",
      //         trigger: "blur"
      //       },
      //       spreadBgp2: {
      //         required: true,
      //         message: "请输入活动分享文案",
      //         trigger: "blur"
      //       },
      //       everydaySpreadInfoTouchValue: {
      //         required: true,
      //         message: "请输入金额"
      //       }
      //     },
      //     spreadActivityBasicInfo: {
      //       spreadTarget: "",
      //       spreadName: "",
      //       spreadStartTime: "",
      //       spreadEndTime: "",
      //       spreadBgm: "",
      //       spreadBgp1: "",
      //       spreadBgp2: "",
      //       spreadBgp3: "",
      //       visualJoinNum: "",
      //       spreadBgp4: "",
      //       spreadShareContent: "",
      //       spreadBgp5: "",
      //       spreadRuleRemark: "",
      //       spreadBgv: ""
      //     },
      //     spreadActivityRule: {
      //       totalMonery: "",
      //       stopSHowMsg: "",
      //       everydaySpreadType: "",
      //       everydaySpreadInfoTouchValue: "",
      //       everydaySpreadInfo: {
      //         touchValue: "",
      //         upperLimit: "",
      //         lowerLimit: ""
      //       },
      //       spreadWarnInfo: {
      //         touchValue: "",
      //         upperLimit: "",
      //         lowerLimit: ""
      //       },
      //       spreadWarnRemind: {
      //         touchValue: "",
      //         contactsTel: ""
      //       }
      //     }
      //   }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("resize", this.handleResize, true);
    this.calcHeight();
    this.type = this.$route.query.type;

    this.ruleForm.spreadTarget = this.$route.query.spreadTarget;
    if (this.type !== "add") {
      this.id = this.$route.query.id;
      this.queryDetails();
    }
    if (this.type === "details") {
      this.disabled = true;
    }
    if (this.$route.query.spreadTarget === "guider") {
      this.labelName = "可参与活动的导购：";
    } else if (this.$route.query.spreadTarget === "supplier") {
      this.labelName = "可参与活动的业务员：";
    } else if (this.$route.query.spreadTarget === "store") {
      this.labelName = "可参与活动的采购：";
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    async querySpreadMember() {
      let params = {
        spreadTarget: this.ruleForm.spreadTarget,
        memberPhoneList: this.memberPhoneList
      };
      const { code, result } = await this.$store.dispatch(
        "querySpreadMember",
        params
      );

      if (code === "0") {
        const { succeeList, errorList } = result;
        if (succeeList.length) {
          this.ruleForm.spreadActivityMemberInfos.push.apply(
            this.ruleForm.spreadActivityMemberInfos,
            succeeList
          );
          this.ruleForm.spreadActivityMemberInfos = arrayUnique2(
            this.ruleForm.spreadActivityMemberInfos,
            "fromId"
          );
        }

        if (errorList.length) {
          this.errValidGoods = true;
          this.errInputResult = errorList;
        }
        this.$refs.ruleForm.validateField("memberFromType");
      }
    },
    async queryDetails() {
      const { code, result } = await this.$store.dispatch(
        "detailsRedpackageSpreadActivity",
        {
          id: this.id
        }
      );
      if (code === "0") {
        const {
          spreadActivityBasicInfo,
          spreadActivityRule,
          columnsInfoModels,
          memberFromType,
          spreadActivityMemberInfos
        } = result;
        this.$refs.hmform.list = columnsInfoModels;
        for (let key in spreadActivityBasicInfo) {
          if (this.ruleForm.hasOwnProperty(key)) {
            this.ruleForm[key] = spreadActivityBasicInfo[key];
          }
        }
        this.ruleForm.memberFromType = memberFromType;
        if (memberFromType != "0") {
          this.ruleForm.spreadActivityMemberInfos = spreadActivityMemberInfos;
        }
        this.ruleForm.activityDate = [
          spreadActivityBasicInfo.spreadStartTime,
          spreadActivityBasicInfo.spreadEndTime
        ];
        for (let key in spreadActivityRule) {
          if (this.ruleForm.hasOwnProperty(key)) {
            this.ruleForm[key] = spreadActivityRule[key];
          }
        }
        this.ruleForm.everydaySpreadInfoTouchValue =
          spreadActivityRule.everydaySpreadInfo.touchValue;

        this.ruleForm.everydaySpreadInfoLowerLimit =
          spreadActivityRule.everydaySpreadInfo.lowerLimit;

        this.ruleForm.everydaySpreadInfoUpperLimit =
          spreadActivityRule.everydaySpreadInfo.upperLimit;

        this.ruleForm.spreadWarnInfoTouchValue =
          spreadActivityRule.spreadWarnInfo.touchValue;

        this.ruleForm.spreadWarnInfoUpperLimit =
          spreadActivityRule.spreadWarnInfo.upperLimit;

        this.ruleForm.spreadWarnInfoLowerLimit =
          spreadActivityRule.spreadWarnInfo.lowerLimit;

        this.ruleForm.spreadWarnRemindTouchValue =
          spreadActivityRule.spreadWarnRemind.touchValue;

        // this.ruleForm.contactsTel =
        //   spreadActivityRule.spreadWarnRemind.contactsTel;

        this.ruleForm.shareSpreadRestrictTouchValue =
          spreadActivityRule.shareSpreadRestrict.touchValue;

        this.ruleForm.shareSpreadRestrictUpperLimit =
          spreadActivityRule.shareSpreadRestrict.upperLimit;

        this.ruleForm.shareSpreadRestrictLowerLimit =
          spreadActivityRule.shareSpreadRestrict.lowerLimit;
      }
    },
    searchByPhone() {
      let memberMobiles = [];
      this.ruleForm.inputMobiles.split(/[(\r\n)\r\n]+/).forEach(v => {
        if (v !== "") {
          memberMobiles.push(v.replace(/\s*/g, ""));
        }
      });
      this.memberPhoneList = memberMobiles;
      this.querySpreadMember();
    },
    removeGoods(index) {
      this.ruleForm.spreadActivityMemberInfos.splice(index, 1);
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["手机号"];
        const data = [];

        exportJsonToExcel(tHeader, data, "导入手机号模板");
      });
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        that.memberPhoneList = [];
        let isValid = true;
        let isRequired = true;
        result.forEach(v => {
          // if (!v[0] || !v[1] || !v[2] || !v[3] || !v[4] || !v[5]) {
          //   isRequired = false;
          // } else {
          //   if (!that.isString(v[3]) || !that.isString(v[4])) {
          //     isValid = false;
          //   }
          // }
          that.memberPhoneList.push(v[0]);
        });
        if (isValid && isRequired) {
          that.querySpreadMember();
          // that.memberCount = formatResult.length;
        } else {
          if (!isRequired) {
            that.$message({
              message: "导入失败，请导入完整商品信息！",
              type: "warning"
            });
          } else if (!isValid) {
            that.$message({
              message: "导入失败，日期请使用文本格式导入！",
              type: "warning"
            });
          }
        }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    uploadVideoProcess(event, file) {
      this.videoFlag = true;
      this.videoUploadPercent =
        file.percentage < 100 ? Math.round(file.percentage) : 99;
    },
    beforeUploadVideo(file) {
      const isLt10M = file.size / 1024 / 1024 < 100;
      if (
        [
          "video/mp4"
          // "video/ogg",
          // "video/flv",
          // "video/avi",
          // "video/wmv",
          // "video/rmvb"
        ].indexOf(file.type) === -1
      ) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
      if (!isLt10M) {
        this.$message.error("上传视频大小不能超过100MB哦!");
        return false;
      }
    },
    handleVideoSuccess(res) {
      //获取上传图片地址
      if (res.code === 0) {
        this.ruleForm.spreadBgv = res.result;
      } else {
        this.$message.error("视频上传失败，请重新上传！");
      }
      this.videoFlag = false;
      this.videoUploadPercent = 0;
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
      this.uploadShow = false;
    },
    // 移除上传文件
    handleRemove(spreadBgp) {
      this.ruleForm[spreadBgp] = "";
    },
    handleRemoveSpreadBgv() {
      this.ruleForm.spreadBgv = "";
    },
    cropUploadSuccess(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.spreadBgp1 = jsonData.result;
        this.uploadShow = false;
      }
    },
    cropUploadSuccess2(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.spreadBgp2 = jsonData.result;
        this.uploadShow = false;
      }
    },
    cropUploadSuccess3(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.spreadBgp3 = jsonData.result;
        this.uploadShow = false;
      }
    },
    cropUploadSuccess4(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.spreadBgp4 = jsonData.result;
        this.uploadShow = false;
      }
    },
    cropUploadSuccess5(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.spreadBgp5 = jsonData.result;
        this.uploadShow = false;
      }
    },
    // 正在上传
    uploading() {
      this.uploadShow = true;
    },
    // 上传前对文件的大小的判断
    beforeAvatarUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      // const limitSize = file.size / 1024 <= 100;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      // if (!limitSize) {
      //   this.$message({
      //     message: "上传模板大小不能超过 100k!",
      //     type: "warning"
      //   });
      // }
      return extension || extension2 || extension3 || extension4;
    },
    handleResize() {
      this.calcHeight();
    },
    handleScroll(e) {
      this.steps.map((v, i) => {
        const ele = document.getElementById(v.id);
        if (ele) {
          const offsetTop = ele.offsetTop;
          if (e.target.scrollTop + 360 > offsetTop) {
            this.currentStep = i + 1;
          } else if (e.target.scrollTop < 100) {
            this.currentStep = 1;
          } else {
            this.currentStep = i - 1;
          }
        }
      });
    },
    calcHeight() {
      setTimeout(() => {
        const headerHeight = document.querySelector(".navbar")
          ? document.querySelector(".navbar").getBoundingClientRect().y
          : 0;
        const tagHeight = document.querySelector(".tags-view-container")
          ? document
              .querySelector(".tags-view-container")
              .getBoundingClientRect().y
          : 0;
        const stepsHeight = document.querySelector(".step-wrapper")
          ? document.querySelector(".step-wrapper").getBoundingClientRect().y
          : 0;
        const footerHeight = document.querySelector(".el-footer")
          ? document.querySelector(".el-footer").getBoundingClientRect().height
          : 0;
        this.scrollHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          80;
      }, 0);
    },
    filterGt0OrFixed0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    filterGt0OrFixed2(prop) {
      //   if (prop === "commissionTerminal" || prop === "commissionSuperior") {
      //     this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      //   }
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    //0.00转0
    verify() {
      this.ruleForm.totalMonery = new Number(this.ruleForm.totalMonery);
      this.ruleForm.everydaySpreadInfoTouchValue = new Number(
        this.ruleForm.everydaySpreadInfoTouchValue
      );
      this.ruleForm.everydaySpreadInfoLowerLimit = new Number(
        this.ruleForm.everydaySpreadInfoLowerLimit
      );
      this.ruleForm.everydaySpreadInfoUpperLimit = new Number(
        this.ruleForm.everydaySpreadInfoUpperLimit
      );
      this.ruleForm.spreadWarnInfoTouchValue = new Number(
        this.ruleForm.spreadWarnInfoTouchValue
      );
      this.ruleForm.spreadWarnInfoLowerLimit = new Number(
        this.ruleForm.spreadWarnInfoLowerLimit
      );
      this.ruleForm.spreadWarnInfoUpperLimit = new Number(
        this.ruleForm.spreadWarnInfoUpperLimit
      );
      this.ruleForm.spreadWarnRemindTouchValue = new Number(
        this.ruleForm.spreadWarnRemindTouchValue
      );
      this.ruleForm.shareRedpackageLowerLimit = new Number(
        this.ruleForm.shareRedpackageLowerLimit
      );
      this.ruleForm.shareRedpackageUpperLimit = new Number(
        this.ruleForm.shareRedpackageUpperLimit
      );
      this.ruleForm.receiveRedpackageLowerLimit = new Number(
        this.ruleForm.receiveRedpackageLowerLimit
      );
      this.ruleForm.receiveRedpackageUpperLimit = new Number(
        this.ruleForm.receiveRedpackageUpperLimit
      );
      this.ruleForm.shareSpreadRestrictLowerLimit = new Number(
        this.ruleForm.shareSpreadRestrictLowerLimit
      );
      this.ruleForm.shareSpreadRestrictUpperLimit = new Number(
        this.ruleForm.shareSpreadRestrictUpperLimit
      );
    },
    async submitForm(formName) {
      this.verify();
      try {
        const valid = await this.$refs[formName].validate();

        if (valid) {
          let ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
          let params = {
            spreadActivityBasicInfo: {
              spreadTarget: ruleForm.spreadTarget,
              spreadName: ruleForm.spreadName,
              spreadStartTime: ruleForm.activityDate[0],
              spreadEndTime: ruleForm.activityDate[1],
              spreadBgm: ruleForm.spreadBgm,
              spreadBgp1: ruleForm.spreadBgp1,
              spreadBgp2: ruleForm.spreadBgp2,
              spreadBgp3: ruleForm.spreadBgp3,
              spreadBgp4: ruleForm.spreadBgp4,
              spreadBgp5: ruleForm.spreadBgp5,
              visualJoinNum: ruleForm.visualJoinNum,
              spreadShareContent: ruleForm.spreadShareContent,
              spreadRuleRemark: ruleForm.spreadRuleRemark,
              spreadBgv: ruleForm.spreadBgv
            },
            spreadActivityRule: {
              totalMonery: ruleForm.totalMonery,
              stopSHowMsg: ruleForm.stopSHowMsg,
              everydaySpreadType: ruleForm.everydaySpreadType,
              everydaySpreadInfo: {
                touchValue: ruleForm.everydaySpreadInfoTouchValue,
                upperLimit:
                  ruleForm.everydaySpreadInfoUpperLimit >
                  ruleForm.everydaySpreadInfoLowerLimit
                    ? ruleForm.everydaySpreadInfoUpperLimit
                    : ruleForm.everydaySpreadInfoLowerLimit,
                lowerLimit:
                  ruleForm.everydaySpreadInfoUpperLimit >
                  ruleForm.everydaySpreadInfoLowerLimit
                    ? ruleForm.everydaySpreadInfoLowerLimit
                    : ruleForm.everydaySpreadInfoUpperLimit
              },
              spreadWarnInfo: {
                touchValue: ruleForm.spreadWarnInfoTouchValue,
                upperLimit:
                  ruleForm.spreadWarnInfoUpperLimit >
                  ruleForm.spreadWarnInfoLowerLimit
                    ? ruleForm.spreadWarnInfoUpperLimit
                    : ruleForm.spreadWarnInfoLowerLimit,
                lowerLimit:
                  ruleForm.spreadWarnInfoUpperLimit >
                  ruleForm.spreadWarnInfoLowerLimit
                    ? ruleForm.spreadWarnInfoLowerLimit
                    : ruleForm.spreadWarnInfoUpperLimit
              },
              spreadWarnRemind: {
                touchValue: ruleForm.spreadWarnRemindTouchValue
                // contactsTel: ruleForm.contactsTel
              },
              shareRedpackageUpperLimit:
                ruleForm.shareRedpackageUpperLimit >
                ruleForm.shareRedpackageLowerLimit
                  ? ruleForm.shareRedpackageUpperLimit
                  : ruleForm.shareRedpackageLowerLimit,
              shareRedpackageLowerLimit:
                ruleForm.shareRedpackageUpperLimit >
                ruleForm.shareRedpackageLowerLimit
                  ? ruleForm.shareRedpackageLowerLimit
                  : ruleForm.shareRedpackageUpperLimit,
              receiveRedpackageUpperLimit:
                ruleForm.receiveRedpackageUpperLimit >
                ruleForm.receiveRedpackageLowerLimit
                  ? ruleForm.receiveRedpackageUpperLimit
                  : ruleForm.receiveRedpackageLowerLimit,
              receiveRedpackageLowerLimit:
                ruleForm.receiveRedpackageUpperLimit >
                ruleForm.receiveRedpackageLowerLimit
                  ? ruleForm.receiveRedpackageLowerLimit
                  : ruleForm.receiveRedpackageUpperLimit,
              shareSpreadRestrict: {
                touchValue: ruleForm.shareSpreadRestrictTouchValue,
                upperLimit:
                  ruleForm.shareSpreadRestrictUpperLimit >
                  ruleForm.shareSpreadRestrictLowerLimit
                    ? ruleForm.shareSpreadRestrictUpperLimit
                    : ruleForm.shareSpreadRestrictLowerLimit,
                lowerLimit:
                  ruleForm.shareSpreadRestrictUpperLimit >
                  ruleForm.shareSpreadRestrictLowerLimit
                    ? ruleForm.shareSpreadRestrictLowerLimit
                    : ruleForm.shareSpreadRestrictUpperLimit
              }
            },
            memberFromType: ruleForm.memberFromType,
            spreadActivityMemberInfos: ruleForm.spreadActivityMemberInfos,
            columnsInfoModels: this.$refs.hmform.list
          };
          let name =
            this.type === "edit"
              ? "editRedpackageSpreadActivity"
              : "createRedpackageSpreadActivity";
          if (this.type === "edit") {
            params.spreadActivityBasicInfo.id = this.id;
          }
          const { code } = await this.$store.dispatch(name, params);
          if (code === "0") {
            this.$message({
              message: "操作成功！",
              type: "success"
            });
            this.$router.back(-1);
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log("error: ", error);
        return;
      }
    },
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    cropSuccess() {}
  }
};
</script>
<style lang='scss' scoped>
.add-goods-container {
  flex-shrink: 0;
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 130px;
    height: 130px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
.priview-bgv {
  position: relative;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 10px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
    z-index: 999;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priview {
  position: relative;
  width: 150px;
  height: 150px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 10px;
  .img {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.act-container {
  max-width: 2000px;
  overflow-x: auto;
  .step-wrapper {
    border-bottom: none !important;
    margin-bottom: 0;
  }
  .add-goods-container {
    width: 1128px;
    flex-shrink: 0;
  }
  .phone-body {
    overflow: hidden !important;
  }
  .slot {
    position: relative;
    background-size: 100% 100%;
    height: 100%;
    &:hover {
      .change-bg {
        display: block;
      }
    }
    .upload-img {
      top: 60px;
    }
    .header-img-wrapper {
      box-sizing: border-box;
      .header-img {
        width: 100%;
        display: block;
      }
    }
    .change-bg {
      position: absolute;
      top: 60px;
      right: 0;
      height: 34px;
      font-size: 12px;
      background-color: rgba(0, 0, 0, 0.8);
      border: 1px solid #fff;
      border-radius: 4px;
      text-align: center;
      line-height: 34px;
      color: #fff;
      z-index: 10;
      padding: 0 10px;
      display: none;
    }
    .empty {
      margin-top: 30px;
      text-align: center;
    }
    .title-img-wrapper {
      margin-left: 10px;
      margin-right: 10px;
      .rolling {
        padding: 0 30px;
        position: absolute;
        top: 46px;
        left: 0;
        right: 0;
        .notice-box {
          height: 30px;
          line-height: 30px;
          padding: 0 10px;
          .notice {
            width: 32px;
            background: #fcb70e;
            border-radius: 34px 0px 0px 34px;
            color: #fff;
          }
          .notice-people {
            font-size: 15px;
            text-align: center;
            color: #f52f1d;
            background: #feecdd;
            border-radius: 0px 34px 34px 0px;
          }
        }

        // div {
        //   border-radius: 50px;
        // }
      }
    }
    .title-content-wrapper {
      // position: absolute;
      // top: 500px;
      // left: 0;
      // right: 0;
      background: #fff;
      margin: 10px;
      border: 1px solid rgba(221, 221, 221, 1);
      border-radius: 6px;
      .title-content {
        font-weight: bold;
        font-size: 19px;
      }
      .price {
        font-size: 20px;
      }
      .bold {
        font-weight: bold;
      }
    }
  }
}
</style>
